
<script>

import BaseSortDropdown from './BaseSortDropdown';

import { mapActions, mapState } from 'vuex';

export default {
   extends: BaseSortDropdown,

   methods: {
      getSortItems() {
         let self = this;
         $.post(
            this.BARD_HOST + '/category/list',
            {
               'token'      : localStorage.getItem('token')
            },
            function(data) {
               if (!data.error) {
                  for (let cat of data) {
                     let sortItem = {};
                     sortItem.text = cat.c_category;
                     sortItem.attr = cat.recid;
                     self.sortItems.push(sortItem);
                  }
               } else {
                  self.handleFailedAPICall('/category/list', 'CategorySortDropdown', data);
               }
            }
         );
      },

      ...mapActions('global', [
         'changeCurrCategory'
      ]),

      handleSortChange(sort) {
         this.changeCurrCategory({category: sort})
      }
   }
}
</script>

<style lang="scss" scoped>
.sort-dropdown {
   position: relative;
   background: #fff;
   font-size: 10px;
   padding: 4px 2px;
   width: 190px;
   border-radius: 4px;
   color: #a7a7a7;
   border: 1px solid #a7a7a7;

   button {
      border: none;
      text-transform: uppercase;
      color: #a7a7a7;
      width: 100%;
      background-position: 95% center;
   }

   #sort_list {
      position: absolute;
      background: white;
      z-index: 20;
      width: 190px;
      top: 25px;
      left: 0px;
      border: 1px solid gray;
      border-radius: 5px;

      a {
         &:hover {
            background-color: #c0c0c0;
            color: $bard-gold;
         }
      }
   }
}
</style>
